<template>
  <div>
    <pop-modal :visible="visible" title="税收编码" width="100%" :height="100" @cancel="handelCancel">
      <div class="main-content">
        <div class="left-cont">
          <div class="left-edit">
            <div>隐藏设置</div>
          </div>
          <div class="category">
            <a-tree v-model="checkedKeys" :tree-data="treeData" showLine @select="treeSelect" />
          </div>
        </div>
        <div class="right-cont">
          <div class="option-btn">
            <div class="search">
              <a-input
                v-model="searchInfo"
                placeholder="请输入客户编码、名称、税号等信息"
                @pressEnter="search()"
                @change="search()"
              >
                <a-icon slot="prefix" type="search" />
              </a-input>
              <a-button type="primary" @click="search"> 搜索 </a-button>
            </div>
            <div class="edit-group">
              <a-button type="primary" ghost v-if="isModule"> 隐藏 </a-button>
              <a-button type="primary" ghost v-if="isModule"> 修改 </a-button>
              <a-button type="primary" ghost v-if="isModule"> 更新 </a-button>
              <a-button type="primary" ghost v-if="isModule"> 导入 </a-button>
              <a-button type="primary" v-if="!isModule"> 确认赋码 </a-button>
            </div>
          </div>
          <m-table
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onDbClick: isModule && onDbClick,
            }"
            :columns="columns"
            :data-source="listOfData"
            :pages="pages"
            @pro="pro()"
            @next="next()"
            @changeShowCount="changeShowCount"
          ></m-table>
        </div>
      </div>
    </pop-modal>
    <!-- 编辑税收编码编码 -->
    <pop-modal :width="50" :height="80" :isDrag="true" title="税收编码添加" :visible="isEdit" @cancel="cancelForm()">
      <div style="padding: 12px 24px">
        <a-form labelAlign="left">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="任务名称" :labelCol="labelCol" :wrapperCol="wrapperCol" required>
                <a-input v-model="value"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="所属分类" :labelCol="labelCol" :wrapperCol="wrapperCol" required>
                <a-input v-model="value"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="客户税号" :labelCol="labelCol" :wrapperCol="wrapperCol" required>
                <a-input v-model="value"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="简码" :labelCol="labelCol" :wrapperCol="wrapperCol" required>
                <a-input v-model="value"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="邮件地址" :labelCol="labelCol" :wrapperCol="wrapperCol" required>
                <a-input v-model="value"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="地址电话" :labelCol="labelCol" :wrapperCol="wrapperCol" required>
                <a-input type="textarea" v-model="value"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="银行账号" :labelCol="labelCol" :wrapperCol="wrapperCol" required>
                <a-input type="textarea" v-model="value"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol" required>
                <a-input v-model="value"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <div
            :style="{
              position: 'absolute',
              right: 0,
              bottom: 0,
              width: '100%',
              borderTop: '1px solid #e9e9e9',
              padding: '10px 16px',
              background: '#fff',
              textAlign: 'center',
              zIndex: 1,
            }"
          >
            <a-button style="margin: 0 20px" type="primary" @click="submitFrom()">保存</a-button>
            <a-button style="margin: 0 20px" type="primary" @click="cancelForm()">取消</a-button>
          </div>
        </a-form>
      </div>
    </pop-modal>
  </div>
</template>

<script>
import Urls from '@/utils/globel.js'
import { parseParam, searchData } from '@/utils/util.js'
import { environment } from '@/utils/oss.env'
const defaultPages = {
  total: 0,
  pageIndex: 1,
  totalPage: 0,
  showCount: 10,
  currentPage: 1,
  index: -1,
}
export default {
  data() {
    return {
      visible: false,
      searchInfo: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 },
      },
      isEdit: false,
      value: '',
      isCategory: false,
      selectedRowKeys: [],
      columns: [
        {
          title: '编码',
          dataIndex: 'code',
          width: 150,
        },
        {
          title: '合并编码',
          dataIndex: 'combineCode',
          width: 150,
        },
        {
          title: '名称',
          dataIndex: 'name',
          width: 150,
        },
        {
          title: '简码',
          dataIndex: 'shortName',
          width: 150,
        },
        {
          title: '说明',
          dataIndex: 'illustrate',
          width: 150,
        },
        {
          title: '税率',
          dataIndex: 'rate',
          width: 150,
        },
        {
          title: '免税',
          dataIndex: 'addedTaxManage',
          width: 150,
        },
        {
          title: '增值税政策依据',
          dataIndex: 'addedTaxAccord',
          width: 150,
        },
        {
          title: '增值税特殊内容代码',
          dataIndex: 'addedTaxCode',
          width: 150,
        },
        {
          title: '消费税管理',
          dataIndex: 'consumTaxManage',
          width: 150,
        },
        {
          title: '消费税政策依据',
          dataIndex: 'consumTaxAccord',
          width: 150,
        },
        {
          title: '消费税特殊内容代码',
          dataIndex: 'consumTaxCode',
          width: 150,
        },
        {
          title: '关键字',
          dataIndex: 'keyWord',
          width: 150,
        },
        {
          title: '统计局编码',
          dataIndex: 'statisDepardCode',
          width: 150,
        },
        {
          title: '使用税率',
          dataIndex: 'taxRate',
          width: 150,
        },
        {
          title: '汇总项',
          dataIndex: 'collection',
          width: 150,
          customRender: (v) => {
            return v === 'Y' ? '是' : '否'
          },
        },
        {
          title: '是否隐藏',
          dataIndex: 'isHiddle',
          width: 150,
          customRender: (v) => {
            return v === 'Y' ? '是' : '否'
          },
        },
        {
          title: '享受优惠政策',
          dataIndex: 'isEnjoyPolic',
          width: 150,
          customRender: (v) => {
            return v === 'Y' ? '是' : '否'
          },
        },
        {
          title: '优惠政策类型',
          dataIndex: 'policyType',
          width: 150,
        },
      ],
      pages: {
        total: 0,
        pageIndex: 1,
        totalPage: 0,
        showCount: 10,
        currentPage: 1,
        index: -1,
      },
      listOfData: [],
      SsbmCode: '',
      treeUrl: environment.ossDomain + '/ivData/goodsCode/ssflbm.o',
      treeData: [],
      checkedKeys: ['1'],
      defaultExpandedKeys: ['1'],
      treeCode: '1',
      isModule: false, // 判断是否作为弹窗的模块使用，true则具有双击选中事件
    }
  },
  methods: {
    show(module) {
      this.isModule = !!module
      this.visible = true
      this.getCodeList()
      this.getTreeData()
    },
    handelCancel() {
      this.visible = false
      this.initTaxNo()
    },
    initTaxNo() {
      this.treeCode = '1'
      this.searchInfo = ''
      this.SsbmCode = ''
      this.pages = JSON.parse(JSON.stringify(defaultPages))
    },
    async getTreeData() {
      const res = await this.$http.get(this.treeUrl)
      this.treeData = [{ key: '0', title: '商品和服务税收分类编码', children: res }]
    },
    async getCodeList() {
      let params = {
        code: this.treeCode,
        showCount: this.pages.showCount,
        currentPage: this.pages.currentPage,
      }
      const num = parseInt(this.searchInfo, 10)
      if (!isNaN(num)) {
        params['code'] = this.searchInfo
      } else {
        params['name'] = this.searchInfo
      }
      params = parseParam(params)
      if (this.SsbmCode) {
        params = parseParam(searchData(this.SsbmCode))
      }
      const res = await this.$http.get(`${Urls.getCodeList}&${params}`)
      if (res.statusCode === '200') {
        this.listOfData = res.data
        this.pages.total = res.total
        this.pages.totalPage = res.totalPage
        this.maxCode = res.total
      }
    },
    search() {
      this.getCodeList()
    },
    pro() {
      if (this.pages.currentPage > 1) {
        this.pages.currentPage--
        this.getCodeList()
      }
    },
    next() {
      if (this.pages.currentPage < this.pages.totalPage) {
        this.pages.currentPage++
        this.getCodeList()
      }
    },
    treeSelect(selectedKeys, info) {
      this.treeCode = selectedKeys[0]
      this.getCodeList()
    },
    changeShowCount(val) {
      this.pages.showCount = val
      this.pages.currentPage = 1
      this.getCodeList()
    },
    submitFrom() {
      this.isEdit = false
    },
    cancelForm() {
      this.isEdit = false
    },
    onDbClick(selectedRowKeys) {
      this.$emit('emitRowKey', selectedRowKeys)
    },
  },
}
</script>

<style lang="less" scoped>
.main-content {
  display: flex;
  height: 100%;
  .left-cont {
    width: 20%;
    background-color: #e8f5ff;
    height: 100%;
  }
  .right-cont {
    flex: 1;
    padding: 10px 10px 20px 10px;
    overflow: auto;
  }
}
.left-cont {
  .left-edit {
    height: 50px;
    background-color: #d2ebff;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
}
.right-cont {
  display: flex;
  flex-direction: column;
  .option-btn {
    display: flex;
    justify-content: flex-end;
    margin: 15px 0;
    .edit-group {
      margin-left: 10px;
      button {
        margin-right: 10px;
      }
    }
    .search {
      display: flex;
      button {
        margin-left: 10px;
      }
    }
  }
}
</style>
